import { EventCreator } from './EventCreator';

export default EventCreator;
